import { Button, ButtonProps, Image, Text } from '@chakra-ui/react'
import React from 'react'

export const InovalonButton = ({ children, ...props }: ButtonProps) => (
  <Button
    // colorScheme='telegram'
    size="sm"
    bg="green.300"
    color="white"
    overflow="hidden"
    _hover={{ bg: 'green.200' }}
    {...props}>
    <Image
      position="absolute"
      opacity={0.2}
      zIndex={0}
      height="80px"
      src="/images/Inovalon-Logo.svg"
      alt="Ability Logo"
    />
    <Text textShadow="1px 1px 2px #555" fontFamily="Hero-New" fontWeight={500} zIndex={2}>
      {children}
    </Text>
  </Button>
)
